function createErrorHandler() {
  const errors = {};

  function addError(key, message) {
    if (!errors[key]) errors[key] = [];

    errors[key].push(message);
  }

  return [errors, addError];
}

export default createErrorHandler;
